import { Sparkles } from 'lucide-react'
import './CaptionGenerateButton.css'

export function CaptionGenerateButton({ onClick, disabled = false, busy = false }: { onClick: () => void; disabled?: boolean; busy?: boolean }) {
  return <button type="button" className={`caption-generate${busy ? ' is-generating' : ''}`} aria-label="Generate caption draft" aria-busy={busy} title={busy ? 'Generating caption…' : 'Generate caption'} disabled={disabled || busy} onClick={onClick}>{busy ? <span className="caption-generate-spinner" aria-hidden="true" /> : <Sparkles size={16} strokeWidth={1.7} aria-hidden="true" />}</button>
}
